exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ant-table-thead > tr > th.ant-table-column-sort {\n  border-bottom-color: #38BA9B;\n}\n.ant-table-thead .ant-table-column-sorter .on {\n  color: #38BA9B !important;\n}\n.ant-table-thead .ant-table-column-sorter i {\n  font-size: 16px !important;\n}\n.ant-table-thead .anticon-filter.ant-dropdown-trigger {\n  font-size: 16px !important;\n}\n.ant-tag {\n  margin-top: 2px !important;\n  margin-bottom: 2px !important;\n}\n", ""]);

// exports
